import { inject, Service } from '@angular/core'
import { AccountService } from '@awork/_shared/services/account-service/account.service'
import { GoogleAuth } from '@codetrix-studio/capacitor-google-auth'
import { PushNotificationService } from '../push-notification-service/push-notification.service'
import { ModalService } from '../../../shared/services/modal-service/modal.service'

/** Ends the native account session and closes its surfaces. */
@Service()
export class MobileLogoutService {
  private readonly accountService = inject(AccountService)
  private readonly pushNotificationService = inject(PushNotificationService)
  private readonly modalService = inject(ModalService)

  /** Unregisters push notifications and signs out of the app and Google. */
  logout(): void {
    this.pushNotificationService.unregister()
    this.accountService.logout()
    GoogleAuth.signOut().catch(() => {})
    this.modalService.hideAllModals()
  }
}
